import { Flex } from "@chakra-ui/react";

export const Modal = ({ children }: { children: React.ReactNode }) => {
  return (
    <Flex
      position="absolute"
      inset={0}
      bg="blackAlpha.600"
      alignItems="center"
      justifyContent="center"
      p={4}
    >
      <Flex
        direction="column"
        alignItems="center"
        gap={5}
        bg="white"
        borderRadius="lg"
        p={6}
        maxW="sm"
        w="full"
      >
        {children}
      </Flex>
    </Flex>
  );
};
